<template>
  <div class="dimmed">
    <slot></slot>
  </div>
</template>

<script>
export default {
  mounted () {
    let body = document.querySelector('body')
    body.style.overflow = 'hidden'
  },
  destroyed () {
    let body = document.querySelector('body')
    body.style.overflow = 'initial'
  }
}
</script>

<style lang="scss" scoped="scoped">
.dimmed {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.6);

  & > /deep/ * {
    @include positionXYcenter;
  }
}
</style>
